import { addFixedTimeCookie, getCookie } from '@/utils/cookie';
import dayjs from 'dayjs';

const LoginHoldPopupShow = {
    show() {
        const loginHoldPopupShow = getCookie('loginHoldPopup'); 
        if (!!loginHoldPopupShow) { // 有标识，执行关闭逻辑
            return false;
        }
        const endOfDay = dayjs().endOf('day').add(0, 'day');
        addFixedTimeCookie('loginHoldPopup', '1', dayjs(endOfDay).toString());
        return true;
    },
};

export default LoginHoldPopupShow;